import React from "react";
import "./SimpleTextInput.css";
import PenIcon from "../PenIcon/PenIcon";

class SimpleTextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isReadOnly: true,
    };
    this.textInput = React.createRef();

    this.handleOnAccept = this.handleOnAccept.bind(this);
    this.handleOnCancel = this.handleOnCancel.bind(this);
  }

  handleOnAccept() {
    this.setState({
      isReadOnly: true,
    });
    this.props.handleOnAccept();
  }

  handleOnCancel() {
    this.setState({
      isReadOnly: true,
    });

    this.props.handleOnCancel();
  }

  render() {
    return (
      <div className="simple-text-input">
        <label htmlFor={this.props.id}>{this.props.label}</label>
        <input
          style={
            this.state.isReadOnly ? { cursor: "default" } : { cursor: "text" }
          }
          ref={this.textInput}
          type={this.props.type}
          id={this.props.id}
          placeholder={this.props.placeholder}
          value={this.props.value}
          name={this.props.id + "simple-text-input"}
          onChange={(e) => this.props.handleTextInputOnChange(e)}
          spellCheck={false}
          required={this.props.required}
          readOnly={this.state.isReadOnly}
        />
        {this.state.isReadOnly ? (
          <div className="simple-text-input-buttons-container">
            <div
              className="simple-text-input-edit"
              onClick={() => {
                this.textInput.current.focus();
                this.setState({ isReadOnly: false });
              }}
            >
              {this.props.isPassword ? (
                <React.Fragment>Change password</React.Fragment>
              ) : (
                <React.Fragment>
                  <PenIcon /> Edit
                </React.Fragment>
              )}
            </div>
          </div>
        ) : null}
        {this.state.isReadOnly ? null : (
          <div className="simple-text-input-buttons-container">
            <div
              className="simple-text-input-accept"
              onClick={this.handleOnAccept}
            >
              Accept
            </div>
            <div
              className="simple-text-input-cancel"
              onClick={this.handleOnCancel}
            >
              Cancel
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SimpleTextInput;
